import React from 'react'
import styles from './giftCardWalletLoadingCell.module.scss'
import { LoadingSpinner } from '@sendoutcards/quantum-design-ui'

const GiftCardWalletLoadingCell: React.FC<{}> = () => {
  return (
    <div className={styles.rowWrapper}>
      <LoadingSpinner size="medium" />
    </div>
  )
}

export default GiftCardWalletLoadingCell
